import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../services/local/alert-service';
import { App } from '../app';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const alertService = inject(AlertService);
  // Create the basic auth header

  if (req.url.endsWith('/auth/login')) {
    return next(req);
  }

  const credentials = App.credentials;

  if (!credentials) {
    return next(req);
  }

  const authHeader = `Basic ${credentials}`;
  
  // Clone the request and add the authorization header
  const authReq = req.clone({
    headers: req.headers.set('Authorization', authHeader)
  });
  
  // Pass the cloned request with the authorization header to the next handler
  // Redirect to login if 401 response
  return next(authReq).pipe(
    catchError(err => {
      if (err.status === 401) {
        router.navigate(['admin']);
        alertService.showError('Credenciales inválidas.', 'Por favor, inicie sesión de nuevo.');
      }
      throw err;
    })
  );
};